export default {
    init() {
        const primaryNav = document.getElementById('nav-primary');
        const toggleMenuButton = document.querySelectorAll('.menu-toggle');

        if (primaryNav && toggleMenuButton) {
            toggleMenuButton.forEach(el => {
                el.addEventListener('click', e => {
                    e.preventDefault();

                    let res = primaryNav.classList.toggle('open');
                    document.body.classList.toggle('disable-scroll', res);
                });
            });
        }
    }
}
